import { Component, Vue, Watch } from 'vue-property-decorator';
import CmgModal from '@/components/modals/CmgModal/CmgModal.vue';
import { ChipotleUOnboardingPageLoadEvent } from '@/services/analytics/events/chipotle-u-onboarding-page-load';

@Component({
  name: 'CmgStudentRegistrationSuccessModal',
  components: {
    CmgModal
  }
})
export default class CmgStudentRegistrationSuccessModal extends Vue {
  currentVideoIndex = 1;
  private viewedSlides: Set<number> = new Set();

  @Watch('visible')
  visibleChanged(isVisible: boolean) {
    if(isVisible) {
      this.$services.analytics.applyOne({
        account: {
          specialLoyaltyComplete: { "value": 1 }
        }
      });
      this.$services.analytics.send(new ChipotleUOnboardingPageLoadEvent(this.currentVideoIndex));
      this.viewedSlides.add(this.currentVideoIndex);
    }
  }

  @Watch('currentVideoIndex')
  currentVideoIndexChanged() {
    if(this.visible && !this.viewedSlides.has(this.currentVideoIndex)) {
      this.$services.analytics.send(new ChipotleUOnboardingPageLoadEvent(this.currentVideoIndex));
      this.viewedSlides.add(this.currentVideoIndex);
    }
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.studentRegistrationSuccessModal.visible;
  }

  get isFirstVideo(): boolean {
    return this.currentVideoIndex === 1;
  }

  get isSecondVideo(): boolean {
    return this.currentVideoIndex === 2;
  }

  get isThirdVideo(): boolean {
    return this.currentVideoIndex === 3;
  }

  get isFinalSlide(): boolean {
    return this.currentVideoIndex === 4;
  }

  get video1Source(): string | undefined {
    return this.isMobile
      ? this.$appStore.state.cms.images.loyalty.introVideo.mobile
      : this.$appStore.state.cms.images.loyalty.introVideo.desktop;
  }

  get video2Source(): string | undefined {
    return this.isMobile
      ? this.$appStore.state.cms.images.loyalty.youreInVideo.mobile
      : this.$appStore.state.cms.images.loyalty.youreInVideo.desktop;
  }

  get video3Source(): string | undefined {
    return this.isMobile
      ? this.$appStore.state.cms.images.loyalty.benefitsScreenVideo.mobile
      : this.$appStore.state.cms.images.loyalty.benefitsScreenVideo.desktop;
  }

  get backButtonImageUrl(): string {
    return this.$appStore.state.cms.images.icons.rewardsBack.default;
  }

  get closeButtonImageUrl(): string {
    return this.$appStore.state.cms.images.icons.rewardsClose.default;
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get appPromoBackgroundImage(): string | undefined {
    return this.isMobile
      ? this.$appStore.state.cms.images.loyalty.onboardingAppPromoBackground.mobile
      : this.$appStore.state.cms.images.loyalty.onboardingAppPromoBackground.desktop;
  }

  get phoneImage(): string | undefined {
    return this.isMobile
      ? this.$appStore.state.cms.images.loyalty.appPromoPhone.mobile
      : this.$appStore.state.cms.images.loyalty.appPromoPhone.desktop;
  }

  mounted() {
    this.preloadVideo2();
    this.preloadVideo3();
  }

  private preloadVideo2(): void {
    if (this.video2Source) {
      const video = document.createElement('video');
      video.src = this.video2Source;
      video.preload = 'auto';
      video.load();
    }
  }

  private preloadVideo3(): void {
    if (this.video3Source) {
      const video = document.createElement('video');
      video.src = this.video3Source;
      video.preload = 'auto';
      video.load();
    }
  }
  onVideoEnded(): void {
    if (this.isFirstVideo) {
      this.currentVideoIndex = 2;
      this.$nextTick(() => {
        const secondVideo = this.$refs.secondVideo as HTMLVideoElement;
        if (secondVideo) {
          secondVideo.play().catch(err => console.error('Error playing video:', err));
        }
      });
    }
  }

  onBackClick(): void {
    if (this.isThirdVideo) {
      this.currentVideoIndex = 2;
      this.$nextTick(() => {
        const secondVideo = this.$refs.secondVideo as HTMLVideoElement;
        if (secondVideo) {
          secondVideo.play().catch(err => console.error('Error playing video:', err));
        }
      });
    }
  }

  onBackFromFinal(): void {
    this.currentVideoIndex = 3;
    this.$nextTick(() => {
      const thirdVideo = this.$refs.thirdVideo as HTMLVideoElement;
      if (thirdVideo) {
        thirdVideo.play().catch(err => console.error('Error playing video:', err));
      }
    });
  }

  onNextClick(): void {
    if (this.isSecondVideo) {
      this.currentVideoIndex = 3;
      this.$nextTick(() => {
        const thirdVideo = this.$refs.thirdVideo as HTMLVideoElement;
        if (thirdVideo) {
          thirdVideo.play().catch(err => console.error('Error playing video:', err));
        }
      });
    }
  }

  onVideo3Click(): void {
    this.currentVideoIndex = 4;
  }

  onSkip(): void {
    this.currentVideoIndex = 4;
  }

  onClose(): void {
    this.currentVideoIndex = 1;
    this.viewedSlides.clear();
    this.$services.ui.setModalVisibility('studentRegistrationSuccessModal', false);
  }

  onGetAppClick(): void {
    if (this.$services.utils.iOSDevice()) {
      window.open("https://itunes.apple.com/us/app/chipotle/id327228455?mt=8", "_blank");
    } else if (this.$services.utils.androidDevice()) {
      window.open("https://play.google.com/store/apps/details?id=com.chipotle.ordering", "_blank");
    } else {
      window.open("https://www.chipotle.com/app", "_blank");
    }
  }
}